import Analytics from '@wetransfer/transfer/modules/analytics';

import { getTCString } from './tc-model';

export function track(params) {
  // Use GA for third party verification
  Analytics.trackGoogleEvent(params);

  // By default, pass along tcstring
  params.property = getTCString();
  Analytics.trackSnowplowEvent(params);
}

export function acceptAll(context, trackingCategory = 'cmp') {
  Analytics.trackAmplitude({
    action: 'Marketing Opt-in Configured',
    additionalProperties: {
      Status: 'Accepted',
    },
  });
  track({
    category: trackingCategory,
    action: 'click_accept_all',
    label: context,
  });
}

export function rejectAll(context, trackingCategory = 'cmp') {
  Analytics.trackAmplitude({
    action: 'Marketing Opt-in Configured',
    additionalProperties: {
      Status: 'Declined',
    },
  });
  track({
    category: trackingCategory,
    action: 'click_reject_all',
    label: context,
  });
}

export function save(context, trackingCategory = 'cmp') {
  track({
    category: trackingCategory,
    action: 'click_save_exit',
    label: context,
  });
}

export function clickLegal() {
  track({
    category: 'cmp',
    action: 'click_legal',
  });
}

export function clickPrivacyPreferences(trackingCategory = 'cmp') {
  track({
    category: trackingCategory,
    action: 'click_privacy_preferences',
  });
}

export function showModal(trackingCategory = 'cmp') {
  track({
    category: trackingCategory,
    action: 'show_modal',
  });
}

export function showPanel(trackingCategory = 'cmp') {
  track({
    category: trackingCategory,
    action: 'show_panel',
  });
}

// A/B experiments on CCPA banner in the US tracking
export function showCcpaBanner() {
  track({
    category: 'ccpa_banner',
    action: 'show_banner',
  });
}

export function closeCcpaBanner() {
  track({
    category: 'ccpa_banner',
    action: 'click_close_banner',
  });
}

export function clickLinkCcpaBanner() {
  track({
    category: 'ccpa_banner',
    action: 'click_link_banner',
  });
}
